export default {"src":"/_next/static/media/PM.41ebbff4.svg","height":18,"width":18};